import { render, staticRenderFns } from "./ArtistDialog.vue?vue&type=template&id=46263e52"
import script from "./ArtistDialog.vue?vue&type=script&lang=js"
export * from "./ArtistDialog.vue?vue&type=script&lang=js"
import style0 from "./ArtistDialog.vue?vue&type=style&index=0&id=46263e52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports